import ErrorText from "components/shared/errortext/ErrorText"
import styles from "./InputWithLabelAndError.module.scss"

const withLabelAndError = (InputComponent) => {

    const InputWithLabelAndError = (props) => {
        const { control, validations, label, name, icon, placeholder, isRequired, type, errorMessage, ...rest } = props

        const { errors } = control?._formState || {}
        
        return (
            <div className={styles.inputControl}>
                <label className={styles.label} htmlFor={name}>{label} {
                    isRequired ? 
                    <span className={styles.requiredMark}>*</span>
                    : ""}
                </label>
                <InputComponent {...props} />
                <ErrorText>
                    {errors?.[name]?.message || errorMessage || ""}
                </ErrorText>
            </div>
        )
    }

    return InputWithLabelAndError
}

export default withLabelAndError